module.exports = function() {
  return new Worker(__webpack_public_path__ + "5e4183576c647cad8b39.worker.js");
};